module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 31);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Position;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _type = __webpack_require__(43);

var _type2 = _interopRequireDefault(_type);

var _location = __webpack_require__(44);

var _location2 = _interopRequireDefault(_location);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_extends({}, _location2.default, _type2.default));

/**
 * The `Position` component allows you to position your elements relatively or
 * absolutely, as well as vertically and horizontally center them or pin them to
 * one of the 4 corners.
 */
function Position(_ref) {
  var bottom = _ref.bottom,
      children = _ref.children,
      fullWidth = _ref.fullWidth,
      left = _ref.left,
      location = _ref.location,
      right = _ref.right,
      top = _ref.top,
      type = _ref.type,
      zIndex = _ref.zIndex;

  var classes = cx([type], [location], {
    'width-100': fullWidth
  });
  var style = {
    bottom: bottom,
    left: left,
    right: right,
    top: top,
    zIndex: zIndex
  };
  return _react2.default.createElement(
    'div',
    { className: classes, style: style },
    children
  );
}

Position.propTypes = {
  bottom: _propTypes2.default.number,
  children: _propTypes2.default.node.isRequired,
  fullWidth: _propTypes2.default.bool,
  left: _propTypes2.default.number,
  location: _propTypes2.default.oneOf(['topLeft', 'topRight', 'bottomRight', 'bottomLeft', 'all', 'center']),
  right: _propTypes2.default.number,
  top: _propTypes2.default.number,
  type: _propTypes2.default.oneOf(['absolute', 'relative', 'fixed']),
  zIndex: _propTypes2.default.number
};

Position.defaultProps = {
  fullWidth: false,
  type: 'absolute'
};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("classnames/bind");

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Position = __webpack_require__(21);

var _Position2 = _interopRequireDefault(_Position);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Position2.default;

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"absolute":"type__absolute___3D3rm position-absolute","relative":"type__relative___WuFPs position-relative","fixed":"type__fixed___2Ix7P position-fixed"};

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"topLeft":"location__topLeft___3eRME pinTL","topRight":"location__topRight___2Rci- pinTR","bottomRight":"location__bottomRight___285xp pinBR","bottomLeft":"location__bottomLeft___1sR3O pinBL","all":"location__all___UuM_6 pinAll","center":"location__center___1LDaN pinCenter"};

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-position.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-position.js
// module id = 1113
// module chunks = 168707334958949